/** @jsxImportSource @emotion/core */
import React from 'react';
import { css } from '@emotion/core';

import { NavHrefButton } from 'components/styled/Button';

import { LinkedInBlackIcon } from 'assets';

type Props = { ariaLabel?: string; href: string; size?: number | number[] };

const LinkedInButton: React.FC<Props> = ({ href, ariaLabel, size }) => {
	return (
		<>
			<NavHrefButton
				p={0}
				ml={2}
				variant="text"
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				aria-label={ariaLabel}
				color="primary"
				css={css`
					&:hover {
						color: black;
					}
				`}
			>
				<LinkedInBlackIcon size={size ?? [30]} />
			</NavHrefButton>
		</>
	);
};

export default LinkedInButton;
